<!--
Displays a short title at the top - when the user clicks the section expands and rest of the content is shown

@author cm359n
-->
<template>
  <div class="textcontainer">
    <div>
  <table class="texttable">
      <tr>
        <td @click="toggleChev()" class="preview">
            <span>{{ title }}</span>
            <span class="chevronCont">
                <img v-if="expanded" src="@/assets/br_up.svg" title="collapse" alt="collapse">
                <img v-else src="@/assets/br_down.svg" title="expand" alt="expand">
            </span>
        </td>
      </tr>
  </table>
    </div>
    <div :class="'textcontent-' + (expanded ? 'expand' : 'collapse')">
  <table class="texttable">
      <tr >
        <td>
            <slot></slot>
        </td>
      </tr>
  </table>
  </div>
  </div>
</template>

<script setup>
//Utilities
import { ref, defineProps } from 'vue'

//Composables
import { useStringUtil }  from '@/composables/StringMethods.js'

const props = defineProps({
  title: String
})

//Data
const expanded = ref(false)

function toggleChev () {
  expanded.value = !expanded.value
}


</script>

<style scoped>
.chevronCont {
    margin-right: 20px;
    float: right;
}
td.preview {
    height: 52px;
    font-size: 18px;
    color: #003865;
    line-height: 48px;
    font-weight: 700;
    width: 100%;
}
.textcontainer {
    background-color: #f2f2f2;
    border-radius: 12px;
    margin-left: 24px;
    margin-right: 24px;
}
table.texttable {
    overflow: hidden;
    margin-left: 24px;
    margin-right: 24px;
    width: 90%;
}
.content {
  font-size: 16px;
}
.textcontent-expand {
    display: block;
    opacity: 1;
    transition: all 0.3s ease-out;
    border-top: 1px solid #e4e4e4;
    color: #4F5961;
    max-height: 333px;
}
.textcontent-collapse {
    display: block;
    opacity: 0;
    padding: 0;
    overflow: hidden;
    transition: all 0.3s ease-out;
    max-height: 0;
}
td.expandChev {
  text-align: center;
}
</style>
